var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  bottom: ', ';\n  right: ', ';\n  width: ', ';\n  height: ', ';\n  border-radius: 32px;\n  background: ', ';\n  text-align: center;\n  cursor: pointer;\n  box-shadow: 0 0 5px 0 rgba(32, 24, 73, 0.26);\n  border: none;\n  outline: none;\n  display: ', ';\n\n  transform: ', ';\n  transition: all 0.4s;\n\n  @media (min-width: 600px) {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    display: block;\n  }\n'], ['\n  position: fixed;\n  bottom: ', ';\n  right: ', ';\n  width: ', ';\n  height: ', ';\n  border-radius: 32px;\n  background: ', ';\n  text-align: center;\n  cursor: pointer;\n  box-shadow: 0 0 5px 0 rgba(32, 24, 73, 0.26);\n  border: none;\n  outline: none;\n  display: ', ';\n\n  transform: ', ';\n  transition: all 0.4s;\n\n  @media (min-width: 600px) {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    display: block;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import { getNumber, getUnit } from '../utils';

var Button = function Button(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      open = _ref.open;
  return React.createElement(
    'button',
    { className: className, onClick: onClick },
    React.createElement(
      StyledIcon,
      { open: open },
      open ? React.createElement(CloseIcon, null) : React.createElement(OpenIcon, null)
    )
  );
};

var OpenIcon = function OpenIcon() {
  return (/*props*/React.createElement(
      'svg',
      { width: '31', height: '31', viewBox: '0 0 31 31', fill: '#ffffff' },
      React.createElement('path', {
        id: 'path0_fill',
        d: 'M 15.5 28.4865C 24.0604 28.4865 31 22.1096 31 14.2432C 31 6.37692 24.0604 0 15.5 0C 6.93959 0 0 6.37692 0 14.2432C 0 18.1796 1.73771 21.743 4.54667 24.321L 4.54667 31L 9.88369 27.5227C 11.6251 28.145 13.5191 28.4865 15.5 28.4865Z'
      })
    )
  );
};

var CloseIcon = function CloseIcon() {
  return (/*props*/React.createElement(
      'svg',
      { width: '24', height: '23', viewBox: '0 0 24 23', fill: '#ffffff' },
      React.createElement('path', {
        id: 'path0_fill',
        d: 'M 21.9454 21.9454C 22.9217 20.9691 22.9217 19.3862 21.9454 18.4099L 15.2279 11.6924L 22.6525 4.26777C 23.6288 3.29146 23.6288 1.70855 22.6525 0.732227C 21.6762 -0.244076 20.0933 -0.244076 19.117 0.732227L 11.6924 8.15685L 4.26777 0.732243C 3.29145 -0.244076 1.70855 -0.244076 0.732227 0.732243C -0.244076 1.70855 -0.244076 3.29146 0.732227 4.26778L 8.15685 11.6924L 1.43933 18.4099C 0.463017 19.3862 0.463017 20.9691 1.43933 21.9454C 2.41564 22.9217 3.99855 22.9217 4.97487 21.9454L 11.6924 15.2279L 18.4099 21.9454C 19.3862 22.9218 20.9691 22.9218 21.9454 21.9454Z'
      })
    )
  );
};

// const StyledIcon = styled.span`
//   display: block;
//   margin-top: ${props => (props.open ? '-8px' : '5px')};
//   color: white;
//   font-size: ${props =>
//     props.open
//       ? '44px'
//       : `${getNumber(props.theme.buttonSize) / 2.5}${getUnit(
//           props.theme.buttonSize
//         )}`};
//   line-height: ${props =>
//     props.open
//       ? '59px'
//       : `${getNumber(props.theme.buttonSize) / 2.5}${getUnit(
//           props.theme.buttonSize
//         )}`};
// `

var StyledIcon = styled.span(_templateObject);

var StyledButton = styled(Button)(_templateObject2, function (props) {
  return '' + getNumber(props.theme.padding) / 2 + getUnit(props.theme.padding);
}, function (props) {
  return '' + getNumber(props.theme.padding) / 2 + getUnit(props.theme.padding);
}, function (props) {
  return props.theme.buttonSize;
}, function (props) {
  return props.theme.buttonSize;
}, function (props) {
  return props.theme.color;
}, function (props) {
  return props.open ? 'none' : '';
}, function (props) {
  return props.animate ? 'scale(1)' : 'scale(0)';
});

export default StyledButton;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@hype/chatbot/es/components/button.js
// module id = 753
// module chunks = 1